const CopOrderComponent = () => import('@/views/cop/CopOrder/CopOrderView')

export default [
    {
        path:'/CopOrderIndex',
        name:'CopOrderComponent',
        component:CopOrderComponent
    }
]